<template>
	<div>
		<CCard>
			<CCardHeader> Listing des colis en point retrait </CCardHeader>
			<CCardBody>
				<CRow>
					<CCol col="6">
						<vc-date-picker
							v-model="startDate"
							:model-config="modelConfig"
							:masks="masks"
							mode="date">
							<template v-slot="{ inputValue, inputEvents }">
								<div role="group" class="form-group">
									<label>Date de départ</label>
									<div class="input-group">
										<input
											type="string"
											class="form-control"
											:value="inputValue"
											v-on="inputEvents" />
										<div class="input-group-append">
											<span class="input-group-text">
												<CIcon name="cil-calendar" />
											</span>
										</div>
									</div>
								</div>
							</template>
						</vc-date-picker>
					</CCol>
					<CCol col="6">
						<vc-date-picker
							v-model="endDate"
							:model-config="modelConfig"
							:masks="masks"
							mode="date">
							<template v-slot="{ inputValue, inputEvents }">
								<div role="group" class="form-group">
									<label>Date de fin</label>
									<div class="input-group">
										<input
											type="string"
											class="form-control"
											:value="inputValue"
											v-on="inputEvents" />
										<div class="input-group-append">
											<span class="input-group-text">
												<CIcon name="cil-calendar" />
											</span>
										</div>
									</div>
								</div>
							</template>
						</vc-date-picker>
					</CCol>

					<CCol col="12" v-if="startDate && endDate">
						<template v-if="loading"> <Loading /> </template>
						<template v-else>
							<GLoadingButton
								label="Télécharger le listing"
								:loading="loadingListing"
								@click="downloadListing"
								class="mb-3" />
							<table class="table table-bordered table-hover">
								<thead>
									<tr>
										<th scope="col">Point retrait</th>
										<th scope="col">Colis</th>
										<th scope="col">Quantité</th>
									</tr>
								</thead>
								<tbody>
									<template v-for="(packages, pickupPointName) in data">
										<tr
											v-for="(item, key, index) in packages"
											:key="'pck' + pickupPointName + key + index">
											<td v-if="index === 0" :rowspan="Object.values(packages).length">
												{{ pickupPointName }}
											</td>

											<td>{{ key }}</td>
											<td>{{ item.quantity }}</td>
										</tr>
									</template>
								</tbody>
							</table>
						</template>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	import Loading from '@/components/loading';
	import GLoadingButton from '@/components/ghostlexly-components/GLoadingButton';
	export default {
		name: 'packages-listing',
		components: { GLoadingButton, Loading },
		data() {
			return {
				startDate: null,
				endDate: null,
				masks: {
					input: 'DD/MM/YYYY',
				},
				modelConfig: {
					type: 'string',
					mask: 'YYYY-MM-DD',
				},
				data: null,
				loading: false,
				loadingListing: false,
			};
		},

		watch: {
			startDate() {
				this.getSummary();
			},
			endDate() {
				this.getSummary();
			},
		},

		methods: {
			getSummary() {
				if (this.startDate && this.endDate) {
					this.loading = true;
					this.$axios
						.get(
							`/api/order_items/stats/pick_up_points?startDate=${this.startDate}&endDate=${this.endDate}`
						)
						.then(res => {
							this.data = res.data;
							this.loading = false;
						})
						.catch(err => {
							this.$toast.error('Une erreur est survenue.');
						});
				}
			},

			downloadListing() {
				this.loadingListing = true;

				let queryParams = new URLSearchParams();
				queryParams.append('order[receiverAddress.companyName]', 'desc');
				queryParams.append('shippingDate[after]', this.startDate);
				queryParams.append('shippingDate[before]', this.endDate);

				this.$axios
					.get(`/api/order_items/list/pick_up_points`, {
						params: queryParams,
						headers: {
							'Content-Type': 'text/csv',
						},
						data: {},
					})
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							let filename = res.headers['content-disposition'];
							filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(filename);
							if (filename != null && filename[1]) {
								filename = filename[1].replace(/['"]/g, '');
							} else {
								filename = 'file.csv';
							}

							const url = window.URL.createObjectURL(new Blob([res.data]));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename); //or any other extension
							document.body.appendChild(link);
							link.click();

							this.loadingListing = false;
						}
					})
					.catch(err => {
						this.loadingListing = false;
						new Blob([err.response.data]).text().then(data => {
							data = JSON.parse(data);
							this.$toast.error(data['hydra:description']);
						});
					});
			},
		},
	};
</script>
